import { type ReactNode } from 'react';
import * as S from './styled';

export type BadgeProps = {
  /** Path to the icon SVG; the SVG shape is used as a mask and painted in `color` */
  icon?: string;
  children?: ReactNode;
  /** Icon and text color */
  color?: string;
  /** Badge background color */
  bgColor?: string;
  /** Badge border color */
  borderColor?: string;
  className?: string;
};

export const Badge = ({
  icon,
  children,
  color = '#000000',
  bgColor = '#FFFFFF',
  borderColor = 'transparent',
  className,
}: BadgeProps) => (
  <S.Frame className={className} $color={color} $bgColor={bgColor} $borderColor={borderColor}>
    {icon && <S.Icon $color={color} src={icon} />}
    {children}
  </S.Frame>
);
